import { generateServiceId } from "@core/domains/identity";

export const SHARED_SERVICE = { ID: generateServiceId("shared") } as const;
